import Permissions from "./Permissions";

export default Permissions;
